import { getMultiStepQuizV4Template, getVueMultiStepQuizV4Template } from "../../shortcodes/templates";

const visualizeMultiStepQuizV4 = content => {
  const multiStepQuizes = content.querySelectorAll('[data-wrapper-id="multi-step-quiz-v4-shortcode"]');
  if (multiStepQuizes.length > 0) {
    multiStepQuizes.forEach(item => {
      item.innerHTML = getMultiStepQuizV4Template();
    });
  }
};

const serializeMultiStepQuizV4 = content => {
  const multiStepQuizWidget = content.querySelectorAll('[data-wrapper-id="multi-step-quiz-v4-shortcode"]');
  if (multiStepQuizWidget.length > 0) {
    multiStepQuizWidget.forEach(item => {
      const quizData = item.getAttribute("data-multi-step-quiz-data");
      item.innerHTML = getVueMultiStepQuizV4Template(quizData);
    });
  }
};

export { visualizeMultiStepQuizV4, serializeMultiStepQuizV4 };
